var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isSafari
        ? [_c("safari-Blocked")]
        : [
            _c("div", { staticClass: "login-container" }, [
              _c(
                "form",
                { staticClass: "form-signin" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("nuxt"),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex f-center f-j-center" }, [
                    _c(
                      "small",
                      { staticClass: "mt-2 mb-3 text-center color-white" },
                      [_vm._v("© " + _vm._s(_vm.year))]
                    ),
                  ]),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center mb-4" }, [
      _c("div", { staticClass: "blinki-logo-container" }, [
        _c("div", { staticClass: "blinki-logo" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }